import * as React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { stateOptions } from "data";
import { TextInput } from "../../../runQuote/components/TextInput";
import { FormPhoneInput } from "../../../runQuote/components/FormPhoneInput";
import { DropdownInput } from "../../../runQuote/components/DropdownInput";
import { DatePicker } from "../../../runQuote/components/DatePicker";
import { SwitchInput } from "../../../runQuote/components/SwitchInput";

const GENDER_OPTIONS = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
];

export function InsuredInfo() {
  const {
    control,
    register,
    setValue,
    trigger,
    clearErrors,
    formState: { errors },
  } = useFormContext();
  const [openDob, setOpenDob] = React.useState(false);

  const movedRecently = useWatch({ control, name: "step2.movedRecently" });
  const insuredState = useWatch({ control, name: "step2.state" });
  const insuredZip = useWatch({ control, name: "step2.zip" });
  const priorState = useWatch({ control, name: "step2.priorState" });
  const priorZip = useWatch({ control, name: "step2.priorZip" });
  const zipErrorMessage = errors?.step2?.zip?.message;
  const priorZipErrorMessage = errors?.step2?.priorZip?.message;

  React.useEffect(() => {
    if (insuredState && insuredZip) {
      void trigger("step2.zip");
    }
  }, [insuredState, insuredZip, trigger]);

  React.useEffect(() => {
    if (insuredState && insuredZip) return;
    if (zipErrorMessage === "This zip code is not valid for this state.") {
      clearErrors("step2.zip");
    }
  }, [insuredState, insuredZip, clearErrors, zipErrorMessage]);

  React.useEffect(() => {
    if (movedRecently && priorState && priorZip) {
      void trigger("step2.priorZip");
    }
  }, [movedRecently, priorState, priorZip, trigger]);

  React.useEffect(() => {
    if (movedRecently && priorState && priorZip) return;
    if (priorZipErrorMessage === "This zip code is not valid for this state.") {
      clearErrors("step2.priorZip");
    }
  }, [movedRecently, priorState, priorZip, clearErrors, priorZipErrorMessage]);

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold">Insured</h2>

      <div className="grid gap-6 md:grid-cols-2">
        <TextInput
          register={register}
          label="First Name"
          id="insuredFirstName"
          stepName="step2.firstName"
          stepId="step2"
        />
        <TextInput
          register={register}
          label="Last Name"
          id="insuredLastName"
          stepName="step2.lastName"
          stepId="step2"
        />
        <DatePicker
          control={control}
          open={openDob}
          setOpen={setOpenDob}
          label="Date of Birth"
          name="step2.dateOfBirth"
          step="step2"
        />
        <DropdownInput
          control={control}
          label="Gender"
          dropdownLabel="Select Gender"
          stepName="step2.gender"
          stepId="step2"
          itemList={GENDER_OPTIONS}
        />
        <TextInput
          register={register}
          label="Insured Email"
          id="insuredEmail"
          stepName="step2.email"
          stepId="step2"
        />
        <FormPhoneInput
          register={register}
          setValue={setValue}
          label="Insured Phone Number"
          id="insuredPhone"
          stepName="step2.phone"
          stepId="step2"
        />
      </div>

      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-slate-900">Insured Address</h3>
        <div className="grid gap-6 md:grid-cols-2">
          <TextInput
            register={register}
            label="Address"
            id="insuredAddress1"
            stepName="step2.address1"
            stepId="step2"
          />
          <TextInput
            register={register}
            label="Address Line 2 (apt #, etc.)"
            id="insuredAddress2"
            stepName="step2.address2"
            stepId="step2"
          />
          <TextInput
            register={register}
            label="City"
            id="insuredCity"
            stepName="step2.city"
            stepId="step2"
          />
          <DropdownInput
            control={control}
            label="State"
            dropdownLabel="Select State"
            stepName="step2.state"
            stepId="step2"
            itemList={stateOptions}
          />
          <TextInput
            register={register}
            label="Zip"
            id="insuredZip"
            stepName="step2.zip"
            stepId="step2"
          />
        </div>
      </div>

      <div className="space-y-4">
        <SwitchInput
          control={control}
          id="movedRecently"
          stepName="step2.movedRecently"
          stepId="step2"
          label="Has the insured moved in the past 2 months?"
        />

        {movedRecently && (
          <div className="grid gap-6 md:grid-cols-2">
            <TextInput
              register={register}
              label="Prior Mailing Address"
              id="priorAddress"
              stepName="step2.priorAddress"
              stepId="step2"
            />
            <TextInput
              register={register}
              label="Prior City"
              id="priorCity"
              stepName="step2.priorCity"
              stepId="step2"
            />
            <DropdownInput
              control={control}
              label="Prior State"
              dropdownLabel="Select State"
              stepName="step2.priorState"
              stepId="step2"
              itemList={stateOptions}
            />
            <TextInput
              register={register}
              label="Prior Zip"
              id="priorZip"
              stepName="step2.priorZip"
              stepId="step2"
            />
          </div>
        )}
      </div>
    </div>
  );
}
